interface CreditsDisplayProps {
  balance: number;
}

export function CreditsDisplay({ balance }: CreditsDisplayProps) {
  return (
    <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
      <span className="font-medium text-foreground">{balance}</span>
      <span>credit{balance !== 1 ? 's' : ''}</span>
    </div>
  );
}
